import React from 'react';
import moment from "moment/moment";
import FormGroupPlainText from "../formGroupPlainText";
import GeneralSVG from "../generalSVG";
import DownloadIcon from "../icons/downloadIcon";

const PolicyTabWording = (props) => {
    const {wordingFile, policyLiveDate, handleClick, aragReference} = props;
    let label = <div>
        <p className="applicationPolicy-paragraph textBold">{aragReference}</p>
        <p className="applicationPolicy-paragraph">{ policyLiveDate? moment(policyLiveDate).format('DD/MM/YYYY HH:mm:ss'):''}</p>
    </div>;
    let value = <div className="">
                    <span className="col-sm-12">
                        {wordingFile.name}
                    </span>
        <div className="col-sm-12">
            <div
                onClick={handleClick}
                className="inlineBlock mousePointer">
                <GeneralSVG
                    SvgWrapper="generalTab-download-wrapper"
                    Label="Download"
                    Svg={<DownloadIcon/>}
                />
            </div>
        </div>
    </div>;

    return (
        <div className="col-sm-12 generalTab-wrapper">
            <form className="form-horizontal">
                <FormGroupPlainText
                    Label={label}
                    InputWrapper="manageSolicitorAccount-data col-xs-9"
                    Text={value}
                />
            </form>
        </div>
    )
};

export default PolicyTabWording;